import {useMemo} from 'react';
import {useSearchParams} from 'react-router';
import {useReportStore} from '../../features/products/useReportStore';

/**
 * Custom hook to determine the effective query for highlighting
 * In AI mode, uses keywords from store; otherwise uses the main query
 * @returns {string} The effective query string
 */
export function useEffectiveQuery() {
    const [searchParams] = useSearchParams();
    const queryParam = searchParams.get('query');
    const aiSearch = searchParams.has('aiSearch');
    const defaultQueryFromStore = useReportStore(s => s.defaultQuery) || '';
    const keywordsFromStore = useReportStore(s => s.keywords) || '';

    return useMemo(() => {
        const baseQuery = (queryParam || defaultQueryFromStore || '').trim();
        // In AI mode, only use keywords for highlighting if available
        return aiSearch ? (keywordsFromStore || '') : baseQuery;
    }, [queryParam, defaultQueryFromStore, keywordsFromStore, aiSearch]);
}
